import axios from 'axios';
import queryString from 'query-string';

const TIMEOUT = 120000;

/**
 * axios instance
 */
const financeiroApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: true,
  responseType: 'json',
  paramsSerializer(params) {
    return queryString.stringify(params, {
      indices: false,
      skipNulls: true,
      skipUndefined: true,
      skipEmptyStrings: true,
    });
  },
});

// request header
financeiroApi.interceptors.request.use((config) => {
  config.timeout = TIMEOUT;
  return config;
});

export default financeiroApi;
